import type { AppSelector } from "src/types";
import type { AuthState } from "./types";

const getModel: AppSelector<AuthState> = (state) => state.authModule;

export const getAccessToken: AppSelector<string | null> = (state) => getModel(state).accessToken;
